module.exports = __webpack_public_path__ + "img/sidebar-home-ico-wht-01.e17f2096.svg";